import { useMutation } from '@tanstack/react-query';

import { resetChatOrchestration } from '../services/api/ai';
import { type OrchestrationResetResponse } from '../types/ai';

export const usePlaygroundOrchestrationReset = () => {
  return useMutation<
    OrchestrationResetResponse,
    Error,
    {
      sessionId: string;
      customerIdHash?: string | null;
    }
  >({
    mutationFn: (payload) => resetChatOrchestration(payload),
  });
};
